import { TovVersionResponseSchema } from "contracts/api/client-tov/version.responses";
import {
  type PlaygroundRunCreateResponse,
  PlaygroundRunCreateResponseSchema,
  PlaygroundRunListResponseSchema,
  PlaygroundRunOutputResponseSchema,
  type PlaygroundUrlCreateRequest,
  PlaygroundUrlCreateResponseSchema,
  type PlaygroundWorkspaceCreateRequest,
  PlaygroundWorkspaceDeleteResponseSchema,
  PlaygroundWorkspaceListResponseSchema,
  PlaygroundWorkspaceSchema,
} from "contracts/api/playground";
import {
  CatalogDraftListResponseSchema,
  CatalogDraftSchema,
  type CatalogDraftWriteRequest,
  PlaygroundCatalogResponseSchema,
} from "contracts/api/playground/draft";
import { ImportableVoiceListResponseSchema } from "contracts/api/playground/tov";
import { request } from "./api-client";

export const playgroundApi = {
  listWorkspaces: () =>
    request(
      "GET",
      "/api/playground/workspaces",
      PlaygroundWorkspaceListResponseSchema,
    ),
  createWorkspace: (input: PlaygroundWorkspaceCreateRequest) =>
    request(
      "POST",
      "/api/playground/workspaces",
      PlaygroundWorkspaceSchema,
      input,
    ),
  deleteWorkspace: (clientId: string) =>
    request(
      "DELETE",
      `/api/playground/workspaces/${clientId}`,
      PlaygroundWorkspaceDeleteResponseSchema,
    ),
  addUrl: (clientId: string, input: PlaygroundUrlCreateRequest) =>
    request(
      "POST",
      `/api/playground/workspaces/${clientId}/websites`,
      PlaygroundUrlCreateResponseSchema,
      input,
    ),
  // Real Clients whose active voice can be imported into a workspace.
  listVoices: () =>
    request("GET", "/api/playground/voices", ImportableVoiceListResponseSchema),
  // Deep-copies a real Client's active voice into the workspace and activates
  // it; returns the freshly activated version.
  importVoice: (clientId: string, sourceClientId: string) =>
    request(
      "POST",
      `/api/playground/workspaces/${clientId}/tov/import`,
      TovVersionResponseSchema,
      { sourceClientId },
    ),
  createRun: (
    websiteId: string,
    catalogDraftId: string | null,
    promptBundleId: string | null,
  ): Promise<PlaygroundRunCreateResponse> =>
    request(
      "POST",
      `/api/playground/websites/${websiteId}/runs`,
      PlaygroundRunCreateResponseSchema,
      { catalogDraftId, promptBundleId },
    ),
  catalog: () =>
    request("GET", "/api/playground/catalog", PlaygroundCatalogResponseSchema),
  listDrafts: () =>
    request("GET", "/api/playground/drafts", CatalogDraftListResponseSchema),
  getDraft: (id: string) =>
    request("GET", `/api/playground/drafts/${id}`, CatalogDraftSchema),
  createDraft: (input: CatalogDraftWriteRequest) =>
    request("POST", "/api/playground/drafts", CatalogDraftSchema, input),
  updateDraft: (id: string, input: CatalogDraftWriteRequest) =>
    request("PUT", `/api/playground/drafts/${id}`, CatalogDraftSchema, input),
  listRuns: (websiteId: string) =>
    request(
      "GET",
      `/api/playground/websites/${websiteId}/runs`,
      PlaygroundRunListResponseSchema,
    ),
  runOutput: (websiteId: string, runId: string) =>
    request(
      "GET",
      `/api/playground/websites/${websiteId}/runs/${runId}`,
      PlaygroundRunOutputResponseSchema,
    ),
  screenshotPath: (runId: string, screenshotId: string) =>
    `/api/playground/runs/${runId}/screenshots/${screenshotId}`,
};
